var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSucces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.112 19.6667L24.2972 36.3333L16.8889 28M3 44.1117V11.8894C3 8.77803 3 7.22117 3.60552 6.03277C4.13815 4.98742 4.98742 4.13815 6.03277 3.60552C7.22117 3 8.77803 3 11.8894 3H44.1117C47.2231 3 48.7766 3 49.965 3.60552C51.0103 4.13815 51.8624 4.98742 52.3951 6.03277C53 7.22001 53 8.77498 53 11.8803V44.121C53 47.2264 53 48.7791 52.3951 49.9663C51.8624 51.0117 51.0103 51.8624 49.965 52.3951C48.7778 53 47.225 53 44.1197 53H11.8803C8.77498 53 7.22001 53 6.03277 52.3951C4.98742 51.8624 4.13815 51.0117 3.60552 49.9663C3 48.7779 3 47.2231 3 44.1117Z",
    stroke: "#80B651",
    strokeWidth: 4.80769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSucces);
export default __webpack_public_path__ + "static/media/mailSucces.811fdd5cd45a61550eeb5d4adfcc87b2.svg";
export { ForwardRef as ReactComponent };